
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@shadcn/components/ui/tabs";

const TopIssuesLists = ({ problemAnalysis, activeIssueTab, setActiveIssueTab }) => {
  if (!problemAnalysis) {
    return (
      <div className="mt-4 p-4 text-center">
        <h3 className="text-lg font-semibold mb-2">Top Issues</h3>
        <p>No problem analysis data available</p>
      </div>
    );
  }

  const issueTypes = [
    { key: 'skus', label: 'Inaccurate SKUs', data: problemAnalysis.topInaccurateSkus || [] },
    { key: 'variance-shortage', label: 'High Shortage Variance Items', data: problemAnalysis.highestShortageVarianceItems || [] },
    { key: 'variance-overage', label: 'High Overage Variance Items', data: problemAnalysis.highestOverageVarianceItems || [] }
  ];

  const renderIssueItem = (item, type) => {
    
    switch (type) {
      case 'skus':
        return (
          <div className="flex justify-between items-center p-3 border rounded-lg hover:bg-gray-50">
            <div>
              <div className="font-medium">{item.sku}</div>
              <div className="text-sm text-gray-600">{item.product}</div>
              <div className={`text-xs ${item.variance < 0 ? 'text-red-500' : 'text-green-500'}`}>
                Variance: {Math.abs(item.variance)}
              </div>
            </div>
            <div className="text-right">
              <div className={`text-lg font-bold ${item.accuracy < 80 ? 'text-red-600' : 'text-yellow-600'}`}>
                {item.accuracy?.toFixed(1)}%
              </div>
            </div>
          </div>
        );

      case 'variance-shortage':
      case 'variance-overage':
        return (
          <div className="flex justify-between items-center p-3 border rounded-lg hover:bg-gray-50">
            <div>
              <div className="font-medium">{item.sku}</div>
              <div className="text-sm text-gray-600">{item.product}</div>
              <div className="text-xs text-gray-500">Accuracy: {item.accuracy?.toFixed(1)}%</div>
            </div>
            <div className="text-right">
              <div className={`text-lg font-bold ${item.varianceValue < 0 ? 'text-red-600' : 'text-green-600'}`}>
                ${Math.abs(item.varianceValue)?.toFixed(2)}
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="mt-4">
      <h3 className="text-lg font-semibold mb-4">Top Issues Requiring Attention</h3>
      
      <Tabs value={activeIssueTab} onValueChange={setActiveIssueTab}>
        <TabsList className="mb-4">
          {issueTypes.map(type => (
            <TabsTrigger key={type.key} value={type.key}>
              {type.label} ({type.data.length})
            </TabsTrigger>
          ))}
        </TabsList>
        
        {issueTypes.map(type => (
          <TabsContent key={type.key} value={type.key}>
            <div className="space-y-3 max-h-96 overflow-y-auto">
              {type.data.length > 0 ? (
                type.data.map((item, index) => (
                  <div key={index}>
                    {renderIssueItem(item, type.key)}
                  </div>
                ))
              ) : (
                <div className="text-center text-gray-500 py-8">
                  No {type.label.toLowerCase()} found
                </div>
              )}
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};

export default TopIssuesLists;
